import { Provider } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { NGX_MAT_DATE_FORMATS, NgxMatDateFormats } from '@angular-material-components/datetime-picker';

export const APP_NGX_MAT_DATE_FORMATS: NgxMatDateFormats = {
  parse:   { dateInput: 'DD/MM/YYYY HH:mm' },
  display: {
    dateInput: 'DD/MM/YYYY HH:mm', 
    monthYearLabel: 'MM/YYYY',
    dateA11yLabel: 'DD/MM/YYYY HH:mm',
    monthYearA11yLabel: 'MM/YYYY',
  },
};

export const DATETIME_GLOBAL_PROVIDERS: Provider[] = [
  { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
  { provide: NGX_MAT_DATE_FORMATS, useValue: APP_NGX_MAT_DATE_FORMATS },
];
